export default {
  salesMan: {
    salesmanName: '业务员名称',
    telephone: '电话号码',
    regionName: '所属地区',
    mobile: '手机号码',
    entryDay: '入职日期',
    createTime: '创建日期',
    modifyTime: '最近修改日期',
    onTheJob: '在职',
    resign: '离职',
    Deleted: '已删除',
    loginAccount: '登录账号',
    loginPassword: '登录密码',
    enclosureList: '附件列表',
    uploadEnclosure: '上传附件',
    birthday: '出生年月',
    fullName: '姓名',
    IDcard: '身份证',
    enclosureType: '附件类型',
    enclosureName: '附件名称',
    enclosureSize: '附件大小',
    uploader: '上传者',
    uploadTime: '上传时间'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cmc/salesman.js